import {RouteProps} from 'react-router-dom'
import { useAuth } from '../../Contexts/AuthContext'
import Edit from '../../Page/Edit'

export default function PrivateRoute({children}:RouteProps) {
  
  const {user} = useAuth()

  return (
    <>
        {
            user
            ? <Edit/>
            : children
        }
    </>
  )
}